import * as t from 'io-ts';

import {makeEnumRuntimeType} from './apiTypes';

/*
 * Runtime type.
 */

export enum DomainValidityStatusesEnum {
  VALID,
  TO_BE_CHECKED,
  INVALID_CONFLICT,
  INVALID_COMMON,
}

const RDomainDirty = t.readonly(
  t.type({
    name: t.string,
    validityStatus: makeEnumRuntimeType(DomainValidityStatusesEnum),
  }),
  'domain',
);

/*
 * Type.
 */

export interface DomainModel extends t.TypeOf<typeof RDomainDirty> {}
export const RDomain = t.clean<DomainModel>(RDomainDirty as any);
